import React from 'react';
import { motion } from 'framer-motion';
import { useLibraryContext } from '../context/LibraryContext.jsx';
import MovieCard from '../components/MovieCard.jsx';

const LibraryPage = ({
    handleMovieClick,
    handleBackToHome
}) => {
    const {
        userLibrary,
        categories,
        activeCategory,
        setActiveCategory,
        openAddCategoryModal,
        addMovieToLibrary,
        removeMovieFromLibrary,
        openAddToCategoryModal,
        getFilteredLibraryMovies,
        handleGetRecommendationsForCategory,
    } = useLibraryContext();

    const filteredLibraryMovies = getFilteredLibraryMovies(activeCategory);
    return (
        <section className="mb-12">
            <motion.button
                onClick={handleBackToHome}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="mb-8 bg-[#141414] hover:bg-[#333] text-white font-bold py-2 px-6 transition duration-300 ease-in-out flex items-center shadow-md"
            >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                Back to Home
            </motion.button>

            <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
                <h2 className="text-4xl font-extrabold text-white mb-4 sm:mb-0">Your Movie Library</h2>
                <div className="flex space-x-3">
                    <motion.button
                        onClick={openAddCategoryModal}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-6 transition duration-300 ease-in-out shadow-lg flex items-center"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                        New Category
                    </motion.button>
                    <motion.button
                        onClick={() => handleGetRecommendationsForCategory(activeCategory)}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-6 transition duration-300 ease-in-out shadow-lg flex items-center"
                    >
                        ✨ Get AI Recommendations
                    </motion.button>
                </div>
            </div>

            {/* Category Navigation */}
            <div className="flex flex-wrap gap-3 mb-8 justify-center sm:justify-start">
                {categories.map(cat => (
                    <motion.button
                        key={cat.id}
                        onClick={() => setActiveCategory(cat.id)}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className={`py-2 px-5 text-lg font-medium transition duration-300 ease-in-out ${activeCategory === cat.id ? 'bg-[#e50914] text-white shadow-lg' : 'bg-[#141414] text-gray-300 hover:bg-[#333] hover:text-white'}`}
                    >
                        {cat.name}
                    </motion.button>
                ))}
            </div>

            {filteredLibraryMovies.length > 0 ? (
                <div className="flex justify-center w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                        {filteredLibraryMovies.map((movie, index) => (
                            <MovieCard
                                key={`library-${movie.id}`}
                                movie={movie}
                                index={index}
                                onCardClick={handleMovieClick}
                                onAddToLibrary={addMovieToLibrary}
                                onRemoveFromLibrary={removeMovieFromLibrary}
                                userLibrary={userLibrary}
                                onManageCategories={openAddToCategoryModal}
                            />
                        ))}
                    </div>
                </div>
            ) : (
                <p className="text-center text-gray-400 text-lg mt-8">
                    {activeCategory === 'all'
                        ? 'Your library is empty. Search for movies and add them!'
                        : `No movies in the "${categories.find(c => c.id === activeCategory)?.name}" category yet.`
                    }
                </p>
            )}
        </section>
    );
};

export default LibraryPage; 